export default "__VITE_ASSET__2lVrBP4B__"